<template>
    <div class="head">
        <div class="nav">
            <ul class="ullist">
                <li v-for="(item,i) in nav" :key="i">
                    <a :href="item.url">{{ item.title }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {inject,ref} from 'vue'
export default {
    name:'Banner',
    setup(){
        let ztreq=inject('ztreq')
        let aurl=ztreq.data.aurl
        let nav=ref([
            {title:'首页',url:"https://www.zgfznews.com/"},
            {title:'重磅推荐',url:"#t1"},
            {title:'换个方式看抚州',url:"#t2"},
            {title:'抚州风光',url:"#t3"},
            {title:'抚州印象',url:"#t4"},
            {title:'红色抚州',url:"#t5"},
            {title:'直播抚州',url:"#t6"}
        ])
        return{
            aurl,nav
        }
    }  

}
</script>

<style scoped>
.head{
    min-width: 1200px;
    width:100%;
    background: url(../assets/header.png) no-repeat top center;
    height: 70px;   
    background-color: #eee;
    padding-top:149px;
}
.nav{
    width: 100%;
    height: 70px;
    background-color: #eee;
    box-sizing: border-box;
    line-height: 70px;
}
.ullist{
    width: 1200px;
    margin: 0 auto;
}
li{
    width: 14%;
    float: left;
    font-size: 20px;
    color: #fff;
    text-align: center;
    list-style: none;
    position: relative;
}
li:hover{
    background-color:#c9c9c9;
}
ul li a{
    color: #4c020f;
    font-size: 20px;
    text-decoration: none;
    display: block;
    cursor: pointer;
}
</style>